import type { DeveloperUiSetting } from '@navio/nsdk';

import type { UserSessionData } from './AuthContext';

/** Writes the real session. Never the impersonated one: that row is the customer. */
export const patchSessionDisabledDeveloperUiSettings = (
  session: UserSessionData,
  disabledDeveloperUiSettings: DeveloperUiSetting[]
): UserSessionData => ({
  ...session,
  user: { ...session.user, disabledDeveloperUiSettings }
});
